import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';

// 🔍 Debug das variáveis de ambiente
console.log('🔍 Firebase Config Debug:', {
  NODE_ENV: process.env.NODE_ENV,
  hasApiKey: !!process.env.REACT_APP_FIREBASE_API_KEY,
  hasProjectId: !!process.env.REACT_APP_FIREBASE_PROJECT_ID,
  useEmulator: process.env.REACT_APP_USE_EMULATOR,
  hostname: typeof window !== 'undefined' ? window.location.hostname : 'server',
  port: typeof window !== 'undefined' ? window.location.port : 'unknown'
});

// Configuração do Firebase usando variáveis de ambiente
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Google Auth Provider
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

// 🎯 DETECÇÃO INTELIGENTE DE AMBIENTE
const isLocalhost = typeof window !== 'undefined' && 
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

const isDevelopment = process.env.NODE_ENV === 'development';
const useEmulators = isLocalhost && isDevelopment;

console.log('🔍 Configuração de ambiente:', {
  isLocalhost,
  isDevelopment,
  useEmulators,
  currentURL: typeof window !== 'undefined' ? window.location.href : 'server',
  hasValidConfig: !!firebaseConfig.apiKey && firebaseConfig.apiKey !== 'your-api-key'
});

// Validar configuração
if (!firebaseConfig.apiKey || firebaseConfig.apiKey === 'your-api-key') {
  console.error('❌ ERRO: Configuração Firebase inválida!', {
    apiKey: firebaseConfig.apiKey,
    projectId: firebaseConfig.projectId,
    envVariables: {
      NODE_ENV: process.env.NODE_ENV,
      hasApiKey: !!process.env.REACT_APP_FIREBASE_API_KEY
    }
  });
  throw new Error('Configuração Firebase inválida. Verifique as variáveis de ambiente.');
}

// Conectar aos emuladores APENAS em desenvolvimento local
if (useEmulators) {
  console.log('🛡️ DESENVOLVIMENTO LOCAL: Conectando aos emuladores...');
  
  try {
    // Conectar ao emulador de Auth ANTES de qualquer operação
    // Configuração especial para evitar problemas de popup
    connectAuthEmulator(auth, 'http://localhost:9099', { 
      disableWarnings: true 
    });
    console.log('✅ Auth Emulator conectado (localhost:9099)');
  } catch (error) {
    console.log('⚠️ Auth emulator erro (pode já estar conectado):', error);
  }

  try {
    // Conectar ao emulador do Firestore
    connectFirestoreEmulator(db, 'localhost', 8080);
    console.log('✅ Firestore Emulator conectado (localhost:8080)');
  } catch (error) {
    console.log('⚠️ Firestore emulator erro (pode já estar conectado):', error);
  }
  
  console.log('🧪 MODO DESENVOLVIMENTO: Usando emuladores Firebase (dados locais e seguros)');
  console.log('🌐 UI Emulador: http://localhost:4040');
  console.log('💡 Para login: Use qualquer email (ex: test@test.com)');
} else {
  console.log('🚀 MODO PRODUÇÃO: Usando Firebase real');
  console.log('🔧 Projeto:', firebaseConfig.projectId);
  console.log('🌍 Auth Domain:', firebaseConfig.authDomain);
}

export default app;
